import { HierarchyNode } from 'types';
export const hasChildren = (object: HierarchyNode) =>
  object.children && !!object.children.length;
